import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'

const TwContainer = tw.div`
  absolute
  top-0
  left-0
  right-0
  bottom-0
  my-auto
  flex
  items-center
  justify-center
`

const TwInner = tw.div`
  flex
  items-center
  mx-16
  py-8
  gap-8
  bg-grey-l100
  rounded-8
  text-secondary
  font-semibold
  text-12
  leading-4
  text-center
  px-8
  py-8
`

interface Props {
  className?: string
}

export const NoMessages = ({className}: Props) => (
  <TwContainer className={className}>
    <TwInner>
      <Icon icon="IconMessage" color="secondary" />
      <span>{Lang.context.rightPanel.noMsg}</span>
    </TwInner>
  </TwContainer>
)
